<div *ngIf="ready">
    <h2 mat-dialog-title>Decline Message</h2>
    <mat-dialog-content class="mat-dialog-content" id="declineReasonContent"><h3>Decline Reasons</h3></mat-dialog-content>
    <mat-dialog-actions class="mat-dialog-actions" id="declineReasonsActions">
        <div *ngFor="let reason of declineReasons; let i = index" id="declineReasons">
            <button [mat-dialog-close]="reason.decline_reason_text" class="spaced_button" color="primary" id="declineBtn{{i}}"
                    mat-raised-button>{{reason.decline_reason_text}}</button>
        </div>
        <div class="right">
            <button [mat-dialog-close]="false" id="cancelBtn" class="spaced_button right" mat-raised-button>Cancel</button>
        </div>
    </mat-dialog-actions>
</div>
